<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
          cols="12"
          md="8"
          lg="6"
          xl="6"
          class="text-center">
        <v-card class="elevation-12" max-width="500">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Изменение пароля') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <v-alert
                class="text-center"
                :value="success"
                type="success">
              {{ $t('Пароль успешно изменен.') }}
            </v-alert>
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="passwordform" @keydown.native.enter="focusOnBtn('changePasswordBtn')">
              <validatable-text-input
                  ref="oldPassword"
                  v-model="oldPassword"
                  rules="required"
                  :label="$t('Старый пароль')"
                  prepend-icon="lock"
                  type="password" />
              <validatable-text-input
                  v-model="newPassword"
                  vid="newPassword"
                  :rules="{ required: true,
                            regex: /[a-zA-Z0-9().,\/#!$%\^&*\;:{}=\-_+>|\?\[\]@]+/ }"
                  :label="$t('Новый пароль')"
                  prepend-icon="lock"
                  type="password" />
              <validatable-text-input
                  v-model="confirmPassword"
                  rules="required|confirmed:newPassword"
                  :label="$t('Подтверждение пароля')"
                  prepend-icon="lock"
                  type="password" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                id="cancelBtn"
                v-test="{ btn: 'cancel' }"
                color="primary"
                :to="`${urlRootPath}/`">
              {{ $t('Отмена') }}
            </v-btn>
            <v-btn
                id="changePasswordBtn"
                ref="changePasswordBtn"
                v-test="{ btn: 'changePassword' }"
                color="primary"
                :disabled="isLoading"
                @click.stop="changePassword">
              {{ $t('Обновить') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import { mapActions } from 'vuex'
  import { ACCOUNT } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextInput
    },
    data () {
      return {
        isLoading: false,
        success: false,
        oldPassword: null,
        newPassword: null,
        confirmPassword: null
      }
    },
    methods: {
      ...mapActions(ACCOUNT.NAMESPACE, {
        changePasswordAction: ACCOUNT.ACTIONS.CHANGE_PASSWORD
      }),
      changePassword: async function () {
        await this.hideErrorAction()
        const result = await this.$refs.passwordform.validate()
        if (!result) {
          return
        }
        this.isLoading = true
        this.success = false
        try {
          await this.changePasswordAction({
            oldPassword: this.oldPassword,
            newPassword: this.newPassword,
            confirmPassword: this.confirmPassword
          })
          this.isLoading = false
          this.success = true
          // токен перезаписывается при успешном ответе
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
